<ng-container *ngFor="let profil of profilCaisseFolio">
  <dsd-container
    margin="none"
    padding="md"
    border-radius="sm"
    class="info-profil-caisse-folio dsd-br-md"
    background-color="dsd-color-background-decorative-graphite-100">
    <div class="dsd-d-flex dsd-ai-baseline">
      <dsd-icon class="dsd-pr-xs" size="sm" icon-name="contenus_contour_caisses"></dsd-icon>
      <p class="dsd-m-0">
        <span class="dsd-fw-bold dsd-b-30">{{ profil.descriptionCaisseCourte }}</span
        ><br />
        <span class="folio dsd-b-40">
          <ng-container *ngFor="let folio of profil.listeFolios; let last = last">
            {{ folio.numeroFolio }}<span *ngIf="!last">, </span>
          </ng-container>
        </span>
      </p>
    </div>
  </dsd-container>
</ng-container>
